<template>
  <div class="route-tabs">
    <Tabs
      v-model:activeKey="activeKey"
      hide-add
      type="editable-card"
      @edit="onEdit"
      @change="onChange"
      size="small"
    >
      <TabPane
        v-for="pane in routePanes"
        :key="pane.path"
        :tab="pane?.query?.alias || pane?.meta?.title"
        :closable="pane?.path !== '/home'"
      ></TabPane>
    </Tabs>
  </div>
</template>
<script setup lang="ts">
import { ref, watch } from 'vue';
import { Tabs } from 'ant-design-vue';
import type { RouteLocationNormalized } from 'vue-router';
const { TabPane } = Tabs;
import { useRouter } from 'vue-router';
const router = useRouter();
const { currentRoute } = router;

const routePanes = ref<RouteLocationNormalized[]>([
  {
    path: '/home',
    fullPath: '/home',
    query: {},
    name: 'Home',
    params: {},
    redirectedFrom: undefined,
    meta: { title: '首页' },
    matched: [],
    hash: '',
  },
]);
const activeKey = ref(routePanes.value[0].path);

const remove = (targetKey: string) => {
  routePanes.value.forEach((pane, i) => {
    if (pane.path === targetKey) {
      let nextTab = routePanes.value[i + 1] || routePanes.value[i - 1];
      if (nextTab) {
        activeKey.value = nextTab.path;
        // 切换路由及菜单
        router.push(nextTab);
      }
    }
  });
  routePanes.value = routePanes.value.filter((pane) => pane.path !== targetKey);
};
const addTabs = (newPath: string) => {
  if (routePanes.value.some((route) => route.path === newPath)) {
    routePanes.value[
      routePanes.value.findIndex((route) => route.path === newPath)
    ] = currentRoute.value;
  } else {
    routePanes.value.push(currentRoute.value);
  }
  activeKey.value = newPath;
};

const onEdit = (targetKey: string) => {
  remove(targetKey);
};
const onChange = (targetKey: string) => {
  console.log('routePanes===>>', routePanes.value);
  let currentRoute =
    routePanes.value.filter((item) => item.path == targetKey)[0] || {};
  router.push({ ...currentRoute });
};
watch(
  () => currentRoute.value.path,
  (newPath) => {
    addTabs(newPath);
  },
  {
    immediate: true,
  }
);
</script>
<style lang="less" scoped>
.route-tabs {
  height: 32px;
  padding-top: 2px;
  line-height: 32px;
  background: @component-background;
  border-bottom: 1px solid @border-color-light;
  border-left: 1px solid @border-color-light;
  padding: 2px 6px 0 6px;
  ::v-deep(.ant-tabs-bar) {
    margin-bottom: 12px !important;
    border: none !important;
  }
  :deep(.ant-tabs) {
    height: 28px !important;
  }
  :deep(.ant-tabs-tab) {
    height: 28px !important;
    padding-right: 12px !important;
    line-height: 28px !important;
    transition: none !important;
    font-size: 12px !important;
  }
  & :deep(.ant-tabs-nav-container) {
    height: auto !important;
  }
}
</style>
